
import { mapGetters } from 'vuex';
import propsForMixin from '../../mixins/props-for';
import ButtonGroup from './ButtonGroup';
import Message from './Message';
import Node from '../common/Node';

export default {
  components: {
    ButtonGroup,
    Message,
    Node,
  },

  mixins: [propsForMixin],

  props: {
    node: {
      type: Object,
      required: true,
    },
    stackIndex: {
      type: Number,
      default: null,
    },
    selectedButtonId: {
      type: String,
      default: '',
    },
    delayedButtons: {
      type: Boolean,
      default: true,
    },
    conversation: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters('chatbotStore', ['isPreview', 'isPreviewRunning']),

    buttonsDelayed() {
      return this.delayedButtons && (!this.isPreview || this.isPreviewRunning);
    },
  },
};
